<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import api from "@/axios";
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import moment from "moment";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import {SimpleBar} from "simplebar-vue3";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {

  components: {
    SimpleBar, Layout, PageHeader, DxDataGrid, DxButton, DxToolbar, DxItem, Loader,
    DxColumn,
    DxPager,  DxFilterRow, DxRemoteOperations,
    DxColumnChooser, DxColumnFixing, DxSelection, DxExport, DxStateStoring, DxGroupPanel, DxGrouping,

  },
  data() {

    return {
      title: "Movimentos CT-e's (Fiscal)",
      items: [
        {
          text: "Fretes",
          href: "/"
        },
        {
          text: "Movimentos CT-e's (Fiscal)",
          active: true
        }
      ],
      dataList: [],
      totalList: 0,
      updating: true,

      dtIniFiltro: null,
      dtFimFiltro: null,
      showModalPeriodo: false,
      submittedPeriodo: false,

      showModalSuporteIA: false,
      chatMessagesData: [],
      submittedMensIa: false,
      mensagemIa: '',
      loadingMensIa: false

    };
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted cte-list_00')
    this.atualizaDataList()
  },


  methods: {

    confMensIa(){
      console.log('confMensIa')
      this.submittedMensIa = true
      if (this.mensagemIa !== ''){
        this.loadingMensIa = true
        this.chatMessagesData.forEach((chat) => {
          console.log('chat')
          console.log(chat.ultima)
          chat.ultima = false
        })
        api.get(`${getBaseUrl()}api/iaprocmens`, {
          params: { mensagemIa: this.mensagemIa }
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.chatMessagesData.push({
            name: res.data[0],
            message: this.mensagemIa,
            time: moment(Date.now()).format('HH:mm:ss'),
            align: 'right',
            ultima: false,
          })
          this.mensagemIa = ''
          this.chatMessagesData.push({
            name: 'Econohelp',
            message: res.data[1],
            time: moment(Date.now()).format('HH:mm:ss'),
            link: res.data[2],
            ultima: true,
          })
          setTimeout(() => {
            var container2 = document.querySelector("#contChatList .simplebar-content-wrapper")
            container2.scrollTo({ top: container2.scrollHeight + 5500, behavior: "smooth" });
            this.$refs.mensagemIa.focus()
          }, 500);
          this.submittedMensIa = false
          this.loadingMensIa = false
        });
      }
    },

    abrirSuporteIA(){
      console.log('abrirSuporteIA')
      if (this.chatMessagesData.length === 0){
        console.log('abrirSuporteIA_0')
        this.chatMessagesData.push({
          name: 'Econohelp',
          message: 'Olá, em que posso ajudar?',
          time: moment(Date.now()).format('HH:mm:ss'),
          ultima: true,
        })
      }
      this.showModalSuporteIA = true
      setTimeout(() => {
        this.$refs.mensagemIa.focus()
      }, 500);
    },

    criarNovoCte(){
      console.log('criarNovoCte')
      this.$router.push(`/movctefiscal/editar/0`)
    },



    nomeStatus(e) {
      switch (e.value) {
        case 'CEM':
          return 'CT-e Emitido (CEM)'
        case 'EL':
          return 'Elaboração (EL)'
        case 'CAN':
          return 'Cancelado (CAN)'
        case 'COL':
          return 'Conciliado (COL)'
      }
      return e.value
    },



    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      this.showModalPeriodo = false
      this.atualizaDataList()
    },


    atualizaDataList(){
      console.log('atualizaDataList_cte')
      this.updating = true
      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }
      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }
      const di = this.dtIniFiltro
      const df = this.dtFimFiltro
      this.updating = false
      this.dataList = new CustomStore({
        key: "id",
        load: function(loadOptions) {
          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'di': di,
            'df': df
          }
          // console.log('paramsReq')
          // console.log(paramsReq)
          return api.get(`${getBaseUrl()}api/movctesfis`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)
            const data = response.data[0];
            const totalCount = response.data[1];
            return {
              data: data,
              totalCount: totalCount,
            }
          })
        },
      })
    },

    carregouGrid(e) {
      console.log('carregouGrid')

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `(${e.component.totalCount()}) Movimentos CT-e's (Fiscal): ${dtIniFormated} - ${dtFimFormated}`
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "movcte_status") {
          const valStatus = e.data.movcte_status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'EL':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'CEM':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'COL':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'CAN':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        } else if (e.column.dataField === "movcte_difvalcota") {
          const valDif = e.data.movcte_difvalcota
          const valFretConc = e.data.movcte_valoratucota
          let corDif = null
          if (valFretConc <= 0 || valDif < 0 ) {
            corDif = 'rgb(248,101,101)'
          } else if (valDif === 0){
            corDif = 'rgba(125,189,110)'
          } else {
            corDif = 'rgb(5,126,236)'
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corDif}`;
        }
      }

    },

    novoCte() {
      console.log('novoCte')

      const routeData = this.$router.resolve(`/movcte/importar/0`)
      window.open(routeData.href, '_blank')
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      const routeData = this.$router.resolve(`/movctefiscal/editar/${idData}`)
      window.open(routeData.href, '_blank')
    },

    onExporting(e) {
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], {type: 'application/octet-stream'}), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },


    refeFormTable() {
      console.log('refeFormTable')
      this.dataGrid.state(null);
    },


    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

  },

};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="upload"
              hint="Importar arquivo de movimento"
              :on-click="novoCte"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              hint="Criar Novo CT-e"
              :on-click="criarNovoCte"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="help"
              hint="Suporte IA"
              :on-click="abrirSuporteIA"/>
        </DxItem>



        <DxItem
            location="center"
            locate-in-menu="never">
          <div class="toolbar-label">Listagem de <b>{{ this.title }}</b></div>
        </DxItem>

      </DxToolbar>

    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="mt-2">

      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @content-ready="carregouGrid"
          @row-dbl-click="onRowDblClick"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true"/>


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>

        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strCteFiscalList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping/>

        <DxColumn :width="80"
                  sort-order="desc"
                  data-field="id"
                  caption="ID"
                  alignment="right"
                  data-type="number"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn
            :width="80"
            data-field="nct"
            caption="Número"
            alignment="right"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            :width="80"
            data-field="natop"
            caption="Natureza"
            alignment="right"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            :width="80"
            data-field="status"
            caption="Status"
            alignment="right"
            data-type="text"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="created_at"
            caption="Criação"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            :width="80"
            data-field="valor"
            caption="Valor"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="peso"
            caption="Peso"
            :format="formatDecimal"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allow-sorting="false"
            :allowHeaderFiltering="false">
        </DxColumn>


        <DxColumn
            :width="100"
            data-field="dhemissao"
            caption="Emissão"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>


        <DxColumn
            :width="330"
            caption="Transportador"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="emitnome"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="emitcnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="emitcidade"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="emitestado"
              caption="Estado"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

        </DxColumn>


        <DxColumn
            :width="330"
            caption="Remetente"
            alignment="center"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="remetnome"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="remetcnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="remetcidade"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="remetestado"
              caption="Estado"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

        </DxColumn>

        <DxColumn
            :width="330"
            caption="Destinatário"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="destnome"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="destcnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="destcidade"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="destestado"
              caption="Estado"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

        </DxColumn>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span>Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span>Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


    <b-modal size="lg" title="Suporte Inteligência Artificial" v-model="showModalSuporteIA" centered hide-footer>

      <div class="row">
        <div class="d-lg-flex">

          <div class="w-100 user-chat">
            <div class="card">
              <div class="p-4 border-bottom">
                <div class="row">
                  <div class="col-md-4 col-9">
<!--                    <h5 class="font-size-15 mb-1">{{ username }}</h5>-->
<!--                    <p class="text-muted mb-0">-->
<!--                      <i class="mdi mdi-circle text-success align-middle me-1"></i>-->
<!--                      Active now-->
<!--                    </p>-->
                  </div>
                  <div class="col-md-8 col-3">
                    <ul class="list-inline user-chat-nav text-end mb-0">
                      <li class="list-inline-item d-none d-sm-inline-block">
                        <b-dropdown
                            menu-class="dropdown-menu-md dropdown-menu-end"
                            variant="white"
                            right
                            toggle-class="nav-btn"
                        >
                          <template v-slot:button-content>
                            <i class="bx bx-search-alt-2"></i>
                          </template>
                          <form class="p-3">
                            <div class="form-group m-0">
                              <div class="input-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Pesquisar..."
                                    aria-label="Recipient's username"
                                />
                                <div class="input-group-append">
                                  <button class="btn btn-primary" type="button">
                                    <i class="mdi mdi-magnify"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </b-dropdown>
                      </li>
                      <li class="list-inline-item d-none d-sm-inline-block">
                        <b-dropdown
                            toggle-class="nav-btn"
                            menu-class="dropdown-menu-end"
                            right
                            variant="white"
                        >
                          <template v-slot:button-content>
                            <i class="bx bx-cog"></i>
                          </template>
                          <b-dropdown-item>Limpar chat</b-dropdown-item>
                        </b-dropdown>
                      </li>

<!--                      <li class="list-inline-item">-->
<!--                        <b-dropdown-->
<!--                            toggle-class="nav-btn"-->
<!--                            menu-class="dropdown-menu-end"-->
<!--                            right-->
<!--                            variant="white"-->
<!--                        >-->
<!--                          <template v-slot:button-content>-->
<!--                            <i class="bx bx-dots-horizontal-rounded"></i>-->
<!--                          </template>-->
<!--                          <b-dropdown-item>Action</b-dropdown-item>-->
<!--                          <b-dropdown-item>Another action</b-dropdown-item>-->
<!--                          <b-dropdown-item>Something else</b-dropdown-item>-->
<!--                        </b-dropdown>-->
<!--                      </li>-->
                    </ul>
                  </div>
                </div>
              </div>


              <div class="chat-users">
                <div class="chat-conversation p-3">
                  <SimpleBar
                      style="max-height: 470px"
                      id="contChatList">
                    <ul class="list-unstyled chat-list">
<!--                      <li>-->
<!--                        <div class="chat-day-title">-->
<!--                          <span class="title">Today</span>-->
<!--                        </div>-->
<!--                      </li>-->
                      <li
                          v-for="data of chatMessagesData"
                          :key="data.message"
                          :class="{ right: `${data.align}` === 'right' }">
                        <div class="conversation-list" >
<!--                          <b-dropdown-->
<!--                              variant="white"-->
<!--                              menu-class="dropdown-menu-end"-->
<!--                          >-->
<!--                            <template v-slot:button-content>-->
<!--                              <i class="bx bx-dots-vertical-rounded"></i>-->
<!--                            </template>-->
<!--                            <b-dropdown-item>Copy</b-dropdown-item>-->
<!--                            <b-dropdown-item>Save</b-dropdown-item>-->
<!--                            <b-dropdown-item>Forward</b-dropdown-item>-->
<!--                            <b-dropdown-item>Delete</b-dropdown-item>-->
<!--                          </b-dropdown>-->
                          <div class="ctext-wrap">
                            <div class="conversation-name">{{ data.name }}</div>

                            <vue-typewriter-effect v-if="data.ultima"  :delete-speed="0" :delay="5" :pause-for="20000" :strings="[data.message]" />
                            <p v-else>{{ data.message }}</p>

                            <a :href="data.link" target="_blank" v-if="data.link"
                               v-b-tooltip.hover placement="top" title="Abrir Link">
                              <i class="mdi mdi-link">Abrir Link</i>
                            </a>

                            <p class="chat-time mb-0 mt-2 me-0 align-content-end end-0">
                              <i class="bx bx-time-five align-middle me-1"></i>
                              {{ data.time }}
                            </p>

                          </div>
                        </div>
                      </li>

                    </ul>
                    <div class="row" v-if="loadingMensIa">
                      <div class="col-12 text-center">
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                      </div>
                    </div>
                  </SimpleBar>
                </div>
                <div class="p-3 chat-input-section">
                  <div class="row">
                    <div class="col">
                      <div class="position-relative">
                        <input
                            type="text"
                            v-on:keydown.enter="confMensIa"
                            ref="mensagemIa"
                            v-model="mensagemIa"
                            class="form-control chat-input rounded"
                            placeholder="Por favor, digite sua dúvida..."
                            :class="{'is-invalid': submittedMensIa && !mensagemIa}"/>
                        <div
                            v-if="submittedMensIa && !mensagemIa"
                            class="invalid-feedback">
                        <span v-if="submittedMensIa && !mensagemIa">
                          Campo mensagem obrigatório, favor preencher.
                        </span>
                        </div>
<!--                        <div class="chat-input-links">-->
<!--                          <ul class="list-inline mb-0">-->
<!--                            <li class="list-inline-item">-->
<!--                              <a-->
<!--                                  href="javascript: void(0);"-->
<!--                                  v-b-tooltip.hover-->
<!--                                  placement="top"-->
<!--                                  title="Adicionar imagem">-->
<!--                                <i class="mdi mdi-file-image-outline"></i>-->
<!--                              </a>-->
<!--                            </li>-->
<!--                            <li class="list-inline-item">-->
<!--                              <a-->
<!--                                  href="javascript: void(0);"-->
<!--                                  v-b-tooltip.hover-->
<!--                                  placement="top"-->
<!--                                  title="Adicionar arquivo">-->
<!--                                <i class="mdi mdi-file-document-outline"></i>-->
<!--                              </a>-->
<!--                            </li>-->
<!--                          </ul>-->
<!--                        </div>-->
                      </div>
                    </div>
                    <div class="col-auto">
                      <button
                          type="button"
                          @click="confMensIa"
                          class="btn btn-primary btn-rounded chat-send w-md">
                        <span class="d-none d-sm-inline-block me-2">Enviar</span>
                        <i class="mdi mdi-send"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </b-modal>


  </Layout>
</template>